

import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const HomeOption2 = lazy(() => import('../pages/home-option2/page'));
const QuienesSomos = lazy(() => import('../pages/quienes-somos/page'));
const QueNosHaceDiferentes = lazy(() => import('../pages/que-nos-hace-diferentes/page'));
const Productos = lazy(() => import('../pages/productos/page'));
const Embajadores = lazy(() => import('../pages/embajadores/page'));
const Distribuidores = lazy(() => import('../pages/distribuidores/page'));
const Contacto = lazy(() => import('../pages/contacto/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/home-option2',
    element: <HomeOption2 />,
  },
  {
    path: '/quienes-somos',
    element: <QuienesSomos />,
  },
  {
    path: '/que-nos-hace-diferentes',
    element: <QueNosHaceDiferentes />,
  },
  {
    path: '/productos',
    element: <Productos />,
  },
  {
    path: '/embajadores',
    element: <Embajadores />,
  },
  {
    path: '/distribuidores',
    element: <Distribuidores />,
  },
  {
    path: '/contacto',
    element: <Contacto />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;

